<ui-object-navigation-main-page alias="pc"></ui-object-navigation-main-page>